import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

import ExpandedTracker from './ExpandedTracker';
import CoupleDashboard from './CoupleDashboard';
import { getUserAccountType, fetchVenueForUser, getUserSelectedVenues } from '../utils/queries';

const Dashboard = () => {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [venues, setVenues] = useState([]);
  const [accountStatus, setAccountStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAccountData() {
      try {
        // 1) Get account type (firestore helper)
        const accountType = await getUserAccountType(user_id);
        setUserType(accountType);

        // 2) Fetch venues based on type
        if (accountType === 'business') {
          const singleVenue = await fetchVenueForUser(user_id);
          setVenues([ typeof singleVenue === 'string'
            ? { id: singleVenue, name: singleVenue }
            : singleVenue
          ]);
        } else if (accountType === 'couple') {
          const selected = await getUserSelectedVenues(user_id);
          setVenues(selected);
        }

        // 3) Fetch account_status from backend
        const { data } = await axios.get(
          'https://api.bestday2marry.com/account_status/',
          {
            params: { user_id },
            withCredentials: true
          }
        );

        if (data.status === 'success') {
          setAccountStatus(data.account_status);
        } else {
          console.error('Error fetching account status –', data.message);
        }
      } catch (err) {
        console.error('Error fetching account data:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchAccountData();
  }, [user_id]);

  // Redirect expired users
  useEffect(() => {
    if (!loading && accountStatus?.expired) {
      const paymentUrl =
        userType === 'business'
          ? `/business_plan/${user_id}`
          : `/matching_flow/${user_id}`;

      navigate(paymentUrl, { state: { expired: true } });
    }
  }, [loading, accountStatus, userType, navigate, user_id]);

  if (loading) {
    return <div>Loading your dashboard...</div>;
  }

  return (
    <div className="dashboard-page">
      {userType === 'couple' ? (
        <CoupleDashboard venues={venues} user_id={user_id} />
      ) : (
        <ExpandedTracker venue={venues[0]} user_id={user_id} />
      )}
    </div>
  );
};

export default Dashboard;